import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 250;
export function ScarcityBar({
  spotsLeft = 17
}: {
  spotsLeft?: number;
}) {
  const [width, setWidth] = useState(0);
  const claimed = TOTAL_SPOTS - spotsLeft;
  const percent = Math.round(claimed / TOTAL_SPOTS * 100);
  useEffect(() => {
    const timeout = window.setTimeout(() => setWidth(percent), 250);
    return () => window.clearTimeout(timeout);
  }, [percent]);
  return <div className="w-full rounded-2xl border border-brand-200 bg-white p-4 shadow-soft" data-id="element-262" data-mp="2g5tk24n6kcvy">
      <div className="flex items-start justify-between gap-3" data-id="element-263" data-mp="2g3gtx479qw7t">
        <p className="flex items-center gap-1.5 text-[12.5px] font-extrabold uppercase tracking-wide text-brand-700" data-id="element-264" data-mp="227dbs99o6ebp">
          <FlameIcon className="h-4 w-4 text-[#E0562B]" aria-hidden="true" data-id="element-265" data-mp="275eu2rz9u9m4" />
          Launch price spots
        </p>
        <p className="shrink-0 text-[12.5px] font-extrabold text-[#C22F2F]" data-id="element-266" data-mp="cuo0mpo20sd">
          Only {spotsLeft} left
        </p>
      </div>
      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-brand-100" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Launch price spots claimed" data-id="element-267" data-mp="33md5n8t5s6qy">
        <div className="h-full rounded-full bg-[#E0562B] transition-[width] duration-700 ease-out" style={{
        width: `${width}%`
      }} data-id="element-268" data-mp="3desnm64ggvbu" />
      </div>
      <p className="mt-2.5 text-[12.5px] font-medium leading-snug text-brand-800/75" data-id="element-269" data-mp="2koixewzutz9m">
        {claimed} of {TOTAL_SPOTS} launch spots already claimed. When the bar fills, the $27
        promotional price closes.
      </p>
    </div>;
}